import { graphql } from '@/gql';
import type { GetSmsTemplateListQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getSmsTemplateList = async ({ smsRecipientName, smsTopicName }: GetSmsTemplateListQueryVariables): Promise<string[]> => {
  const response = await queryExecute({
    query: graphql(`
      query GetSmsTemplateList($smsRecipientName: SmsRecipientName!, $smsTopicName: SmsTopicName!) {
        getSmsTemplateList(smsRecipientName: $smsRecipientName, smsTopicName: $smsTopicName)
      }
    `),
    variables: {
      smsRecipientName,
      smsTopicName,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getSmsTemplateList;
};
